import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import bindMethods from 'auto-bind';

import { setView } from '../state/settings';
import { clearAuthInLocalStorage } from '../utils/localStorage';
import { sortUserSelections } from '../utils/sorting';
import FootballSettings from './Settings/football';
import GenrealSettings from './Settings/general';
import NavigationItemPicker from './NavigationItemPicker';


class GeneralSettingsPicker extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }


  handleChange({ value }) {
    const { setView } = this.props;
    switch (value) {
      case 'general':
        setView('general');
        break;
      case 'football':
        setView('football');
        break;
      case 'logout':
        this.logOut();
        break;
      default:
        break;
    }
    document.activeElement.blur();
  }

  logOut() {
    clearAuthInLocalStorage();
    window.location.reload();
  }

  renderDropdownOptions() {
    const { t, sport } = this.props;
    const selections = [
      {
        label: t('NavigationBar.User.General.Dropdown'),
        value: 'general',
        index: 1,
      },
      {
        label: t('NavigationBar.User.Logout'),
        value: 'logout',
        index: 3,
      },
    ];

    const football = {
      label: t('NavigationBar.User.Football.Dropdown'),
      value: 'football',
      index: 2,
    };

    return sport === 'Football' ? sortUserSelections([...selections, football]) : selections;
  }

  render() {
    const { displayName, activeView } = this.props;
    const isFootball = activeView === 'football';
    const isGeneral = activeView === 'general';

    return (
      <React.Fragment>
        <NavigationItemPicker
          selectId="NavigationBar.DropDown.GeneralSettings"
          value={displayName}
          options={this.renderDropdownOptions()}
          onChange={this.handleChange}
          placeholder={displayName}
          theme="settings"
        />
        { isFootball && <FootballSettings active={isFootball} /> }
        { isGeneral && <GenrealSettings active={isGeneral} /> }
      </React.Fragment>
    );
  }
}

GeneralSettingsPicker.propTypes = {
  t: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired,
  sport: PropTypes.string.isRequired,
  setView: PropTypes.func.isRequired,
  activeView: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

const mapStateToProps = state => ({
  userId: state.user.userId,
  sport: state.sport.sportName,
  displayName: state.user.displayName,
  activeView: state.settings.activeView,
});

const mapDispatchToProps = {
  setView,
};

const TranslatedComponent = withTranslation()(GeneralSettingsPicker);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranslatedComponent);
